__turbopack_context__.v({
  "eyebrow": "OverflowCarouselText-module-scss-module__A4VPWW__eyebrow",
  "eyebrowWrapper": "OverflowCarouselText-module-scss-module__A4VPWW__eyebrowWrapper",
  "fade-in": "OverflowCarouselText-module-scss-module__A4VPWW__fade-in",
  "headline": "OverflowCarouselText-module-scss-module__A4VPWW__headline",
  "headlineInner": "OverflowCarouselText-module-scss-module__A4VPWW__headlineInner",
  "isActive": "OverflowCarouselText-module-scss-module__A4VPWW__isActive",
  "isInitialPaint": "OverflowCarouselText-module-scss-module__A4VPWW__isInitialPaint",
  "isLongest": "OverflowCarouselText-module-scss-module__A4VPWW__isLongest",
  "isPrev": "OverflowCarouselText-module-scss-module__A4VPWW__isPrev",
  "root": "OverflowCarouselText-module-scss-module__A4VPWW__root",
  "slide-up-in": "OverflowCarouselText-module-scss-module__A4VPWW__slide-up-in",
  "slide-up-out": "OverflowCarouselText-module-scss-module__A4VPWW__slide-up-out",
  "textLockup": "OverflowCarouselText-module-scss-module__A4VPWW__textLockup",
});
